import { render, staticRenderFns } from "./SetCommunityProfile.vue?vue&type=template&id=482229ea&scoped=true&"
import script from "./SetCommunityProfile.vue?vue&type=script&lang=js&"
export * from "./SetCommunityProfile.vue?vue&type=script&lang=js&"
import style0 from "./SetCommunityProfile.vue?vue&type=style&index=0&id=482229ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482229ea",
  null
  
)

export default component.exports